// extracted by mini-css-extract-plugin
export default {"content":"Pagination_content__6WIBV","page":"Pagination_page__V9kAb","active":"Pagination_active__xBgf+","icon":"Pagination_icon__JRt4F","hide":"Pagination_hide__98Hs+"};